module.exports = __webpack_public_path__ + "img/bi.0fe266bf.png";